import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { ASYNC_CREATE_COMPANY_RULE, ASYNC_EDIT_COMPANY_RULE } from 'store';
import { Form, Row, Col, Card, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import DatePicker, { registerLocale } from 'react-datepicker';
import { api } from 'services';
import { parseDate } from 'helpers/date';
import ptBR from 'date-fns/locale/pt-BR';
import History from 'components/History';
import Select from 'react-select';
import MasterPage from 'components/MasterPage';
import { DashboardOutlined } from '@material-ui/icons';

registerLocale('pt_BR', ptBR);

const CompanyRulesForm = ({
  createOrEditCompanyRule,
  match: {
    params: { id, year },
  },
}) => {
  const [company, setCompany] = useState('');
  const [period, setPeriod] = useState('');
  const [period_start, setPeriodStart] = useState('');
  const [rules, setRules] = useState([]);
  const [fiscal_year, setFiscalYear] = useState('');
  const [historyComment, setHistoryComment] = useState('');
  const [histories, setHistories] = useState([]);

  const [periodTypes, setPeriodTypes] = useState([]);
  const [fiscalYears, setFiscalYears] = useState([]);
  const [companies, setCompanies] = useState([]);

  var VendorsArr = [];

  const { t } = useTranslation();

  useEffect(() => {
    if (id)
      api.get('companies/rules').then(({ data }) => setCompanies(data));
    else
      api
        .get('companies/without-rules')
        .then(({ data }) => setCompanies(data));

    api.get('period-types').then(({ data }) => setPeriodTypes(data));

    const fiscalYears = [];
    for (var i = 0; i <= 1; i++) {
      if (fiscalYears.length === 0)
        fiscalYears.push(new Date().getFullYear());
      else fiscalYears.push(fiscalYears[fiscalYears.length - 1]++);
    }
    setFiscalYears(fiscalYears.reverse());

    if (id) {
      api.get(`company-rules/${id}/${year}`).then(({ data }) => {
        setCompany(data.id);
        setPeriod(data.period_type_id);
        setPeriodStart(new Date(parseDate(data.period_start)));
        setFiscalYear(data.fiscal_year);

        const cRules = data.rules.filter((f) => !f.deleted_at).map((rule) => ({
          id: rule.id,
          type_name: rule.period.type.name,
          period_id: rule.period.id,
          position: rule.period.position,
          expected_amount_start: new Date(
            parseDate(rule.expected_amount_start)
          ),
          expected_amount_end: new Date(parseDate(rule.expected_amount_end)),
          real_amount_start: new Date(parseDate(rule.real_amount_start)),
          real_amount_end: new Date(parseDate(rule.real_amount_end)),
          plan_start: new Date(parseDate(rule.plan_start)),
          plan_end: new Date(parseDate(rule.plan_end)),
          execution_start: new Date(parseDate(rule.execution_start)),
          execution_end: new Date(parseDate(rule.execution_end)),
          voucher_start: new Date(parseDate(rule.voucher_start)),
          voucher_end: new Date(parseDate(rule.voucher_end)),
          claim_start: new Date(parseDate(rule.claim_start)),
          claim_end: new Date(parseDate(rule.claim_end)),
          refunds_start: new Date(parseDate(rule.refunds_start)),
          refunds_end: new Date(parseDate(rule.refunds_end)),
        }));

        setRules(cRules);
        setHistories(data.rules_histories);
      });
    }
  }, [id, year]);

  const handleChangePeriod = (e) => {
    let updateArray = [];
    periodTypes.forEach((type) => {
      if (type.id === parseInt(e.target.value)) {
        updateArray = type.periods.map((period) => {
          return {
            period_id: period.id,
            type_name: type.name,
            position: period.position,
            expected_amount_start: '',
            expected_amount_end: '',
            real_amount_start: '',
            real_amount_end: '',
            plan_start: '',
            plan_end: '',
            execution_start: '',
            execution_end: '',
            voucher_start: '',
            voucher_end: '',
            claim_start: '',
            claim_end: '',
            refunds_start: '',
            refunds_end: '',
          };
        });
      }
    });
    setPeriod(e.target.value);
    setRules(updateArray);
  };

  const getVendors = () => {
    companies.map((company) => {
      return VendorsArr.push({
        label: company.alias,
        value: company.id,
      });
    });

    VendorsArr.sort((a, b) => {
      return +(a.label > b.label) || +(a.label === b.label) - 1;
    });

    VendorsArr.map((label) => {
      return companies[label.index];
    });
  };

  const findVendors = (value) => {
    let flag;
    VendorsArr.map((v, k) => {
      if (value === v.value) {
        flag = k;
      }
    });
    return flag;
  };

  const handleChangeRule = (name, value, key) => {
    const updateArray = [...rules];
    updateArray[key][name] = value;
    setRules(updateArray);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formatDate = (date) => {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = '0' + month;

      if (day.length < 2) day = '0' + day;

      return [year, month, day].join('-');
    };

    const cRules = [];

    rules.forEach((rule) =>
      cRules.push({
        ...rule,
        ...{
          expected_amount_start: formatDate(rule.expected_amount_start),
          expected_amount_end: formatDate(rule.expected_amount_end),
          real_amount_start: formatDate(rule.real_amount_start),
          real_amount_end: formatDate(rule.real_amount_end),
          plan_start: formatDate(rule.plan_start),
          plan_end: formatDate(rule.plan_end),
          execution_start: formatDate(rule.execution_start),
          execution_end: formatDate(rule.execution_end),
          voucher_start: formatDate(rule.voucher_start),
          voucher_end: formatDate(rule.voucher_end),
          claim_start: formatDate(rule.claim_start),
          claim_end: formatDate(rule.claim_end),
          refunds_start: formatDate(rule.refunds_start),
          refunds_end: formatDate(rule.refunds_end),
        },
      })
    );

    createOrEditCompanyRule({
      id,
      company_id: company,
      period_type_id: period,
      fiscal_year,
      period_start: formatDate(period_start),
      rules: cRules,
      history_comment: historyComment,
    });
  };
  getVendors();
  const readOnlySelect = !!id
    ? {
      style: {
        background: '#eee',
        pointerEvents: 'none',
        touchAction: 'none',
      },
      tabIndex: -1,
    }
    : null;

  return (
    <Form onSubmit={handleSubmit}>
      <Card.Body className="shadow bg-white rounded mb-3">
        <Row>
          <Col className="d-flex mt-3 mb-3">
            <DashboardOutlined className="icon-title" />
            <h4 className="title-dashboard">{company && VendorsArr[findVendors(company)] ? `Regra - ${VendorsArr[findVendors(company)].label}` : t('title:create company rule')}</h4>
          </Col>
        </Row>
        <Row>
          <Col>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:company')}</Form.Label>
                  <Select
                    key={company}
                    name="vendor"
                    mode="input"
                    options={VendorsArr}
                    placeholder={t('label:select')}
                    required
                    isDisabled={!!id}
                    onChange={(e) => {
                      setCompany(e.value);
                    }}
                    defaultValue={VendorsArr[findVendors(company)]}
                    noOptionsMessage={() => t('label:loading')}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:period')}</Form.Label>
                  <Form.Control
                    as="select"
                    value={period}
                    onChange={handleChangePeriod}
                    required
                    {...readOnlySelect}
                  >
                    <option disabled={true} value="">
                      {t('label:select')}
                    </option>
                    {periodTypes.map((type, k) => (
                      <option key={k} value={type.id}>
                        {type.name}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Row>
                    <Col>
                      <Form.Label>{t('label:period start')}</Form.Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <DatePicker
                        locale="pt_BR"
                        dateFormat="dd/MM/yyyy"
                        customInput={<Form.Control />}
                        selected={period_start}
                        onChange={(date) => setPeriodStart(date)}
                        required
                        readOnly={!!id}
                      />
                    </Col>
                  </Row>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:fiscal year')}</Form.Label>
                  <Form.Control
                    as="select"
                    value={fiscal_year}
                    onChange={(e) => setFiscalYear(e.target.value)}
                    required
                    {...readOnlySelect}
                  >
                    <option disabled={true} value="">
                      {t('label:select')}
                    </option>
                    {fiscalYears.map((year, k) => (
                      <option key={k} value={year}>
                        {year}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row
          className="mt-2"
          style={{ display: rules.length === 0 ? 'none' : 'block' }}
        >
          <Col>
            {!!period_start &&
              rules.map((rule, k) => (
                <Card body className="mt-2" key={k}>
                  <Row>
                    <Col>
                      <h5>{`${rule.type_name} ${rule.position}`}</h5>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col>
                      <Form.Group>
                        <Row>
                          <Col>
                            <Form.Label className="mr-2">
                              {t('label:expected amount')}
                            </Form.Label>
                            <span
                              style={{ color: '#D71925' }}
                              data-toggle="tooltip"
                              data-placement="right"
                              title={t('phrase:deadline expected value')}
                            >
                              <i className="danger fas fa-exclamation-circle"></i>
                            </span>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <DatePicker
                              shouldCloseOnSelect={false}
                              locale="pt_BR"
                              dateFormat="dd/MM/yyyy"
                              customInput={<Form.Control />}
                              selected={rule.expected_amount_start}
                              onChange={(date) =>
                                handleChangeRule(
                                  'expected_amount_start',
                                  date,
                                  k
                                )
                              }
                              placeholderText={t('label:start date')}
                              startDate={rule.expected_amount_start}
                              endDate={rule.expected_amount_end}
                              required
                            />
                          </Col>
                          <Col>
                            <DatePicker
                              shouldCloseOnSelect={false}
                              locale="pt_BR"
                              dateFormat="dd/MM/yyyy"
                              customInput={<Form.Control />}
                              selected={rule.expected_amount_end}
                              onChange={(date) =>
                                handleChangeRule('expected_amount_end', date, k)
                              }
                              placeholderText={t('label:end date')}
                              startDate={rule.expected_amount_start}
                              endDate={rule.expected_amount_end}
                              required
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group>
                        <Row>
                          <Col>
                            <Form.Label className="mr-2">
                              {t('label:real amount')}
                            </Form.Label>
                            <span
                              style={{ color: '#D71925' }}
                              data-toggle="tooltip"
                              data-placement="right"
                              title={t('phrase:deadline real value')}
                            >
                              <i className="danger fas fa-exclamation-circle"></i>
                            </span>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <DatePicker
                              minDate={period_start}
                              shouldCloseOnSelect={false}
                              locale="pt_BR"
                              dateFormat="dd/MM/yyyy"
                              customInput={<Form.Control />}
                              selected={rule.real_amount_start}
                              onChange={(date) =>
                                handleChangeRule('real_amount_start', date, k)
                              }
                              placeholderText={t('label:start date')}
                              startDate={rule.real_amount_start}
                              endDate={rule.real_amount_end}
                              required
                            />
                          </Col>
                          <Col>
                            <DatePicker
                              minDate={period_start}
                              shouldCloseOnSelect={false}
                              locale="pt_BR"
                              dateFormat="dd/MM/yyyy"
                              customInput={<Form.Control />}
                              selected={rule.real_amount_end}
                              onChange={(date) =>
                                handleChangeRule('real_amount_end', date, k)
                              }
                              placeholderText={t('label:end date')}
                              startDate={rule.real_amount_start}
                              endDate={rule.real_amount_end}
                              required
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col>
                      <Form.Group>
                        <Row>
                          <Col>
                            <Form.Label className="mr-2">
                              {t('label:plan')}
                            </Form.Label>
                            <span
                              style={{ color: '#D71925' }}
                              data-toggle="tooltip"
                              data-placement="right"
                              title={t('phrase:deadline marketing plan')}
                            >
                              <i className="danger fas fa-exclamation-circle"></i>
                            </span>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <DatePicker
                              minDate={period_start}
                              shouldCloseOnSelect={false}
                              locale="pt_BR"
                              dateFormat="dd/MM/yyyy"
                              customInput={<Form.Control />}
                              selected={rule.plan_start}
                              onChange={(date) =>
                                handleChangeRule('plan_start', date, k)
                              }
                              placeholderText={t('label:start date')}
                              startDate={rule.plan_start}
                              endDate={rule.plan_end}
                              required
                            />
                          </Col>
                          <Col>
                            <DatePicker
                              minDate={period_start}
                              shouldCloseOnSelect={false}
                              locale="pt_BR"
                              dateFormat="dd/MM/yyyy"
                              customInput={<Form.Control />}
                              selected={rule.plan_end}
                              onChange={(date) =>
                                handleChangeRule('plan_end', date, k)
                              }
                              placeholderText={t('label:end date')}
                              startDate={rule.plan_start}
                              endDate={rule.plan_end}
                              required
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group>
                        <Row>
                          <Col>
                            <Form.Label className="mr-2">
                              {t('label:execution')}
                            </Form.Label>
                            <span
                              style={{ color: '#D71925' }}
                              data-toggle="tooltip"
                              data-placement="right"
                              title={t('phrase:deadline execution')}
                            >
                              <i className="danger fas fa-exclamation-circle"></i>
                            </span>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <DatePicker
                              minDate={period_start}
                              shouldCloseOnSelect={false}
                              locale="pt_BR"
                              dateFormat="dd/MM/yyyy"
                              customInput={<Form.Control />}
                              selected={rule.execution_start}
                              onChange={(date) =>
                                handleChangeRule('execution_start', date, k)
                              }
                              placeholderText={t('label:start date')}
                              startDate={rule.execution_start}
                              endDate={rule.execution_end}
                              required
                            />
                          </Col>
                          <Col>
                            <DatePicker
                              minDate={period_start}
                              shouldCloseOnSelect={false}
                              locale="pt_BR"
                              dateFormat="dd/MM/yyyy"
                              customInput={<Form.Control />}
                              selected={rule.execution_end}
                              onChange={(date) =>
                                handleChangeRule('execution_end', date, k)
                              }
                              placeholderText={t('label:end date')}
                              startDate={rule.execution_start}
                              endDate={rule.execution_end}
                              required
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col>
                      <Form.Group>
                        <Row>
                          <Col>
                            <Form.Label className="mr-2">
                              {t('label:voucher')}
                            </Form.Label>
                            <span
                              style={{ color: '#D71925' }}
                              data-toggle="tooltip"
                              data-placement="right"
                              title={t('phrase:deadline comprovation')}
                            >
                              <i className="danger fas fa-exclamation-circle"></i>
                            </span>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <DatePicker
                              minDate={period_start}
                              shouldCloseOnSelect={false}
                              locale="pt_BR"
                              dateFormat="dd/MM/yyyy"
                              customInput={<Form.Control />}
                              selected={rule.voucher_start}
                              onChange={(date) =>
                                handleChangeRule('voucher_start', date, k)
                              }
                              placeholderText={t('label:start date')}
                              startDate={rule.voucher_start}
                              endDate={rule.voucher_end}
                              required
                            />
                          </Col>
                          <Col>
                            <DatePicker
                              minDate={period_start}
                              shouldCloseOnSelect={false}
                              locale="pt_BR"
                              dateFormat="dd/MM/yyyy"
                              customInput={<Form.Control />}
                              selected={rule.voucher_end}
                              onChange={(date) =>
                                handleChangeRule('voucher_end', date, k)
                              }
                              placeholderText={t('label:end date')}
                              startDate={rule.voucher_start}
                              endDate={rule.voucher_end}
                              required
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group>
                        <Row>
                          <Col>
                            <Form.Label className="mr-2">
                              {t('label:claim')}
                            </Form.Label>
                            <span
                              style={{ color: '#D71925' }}
                              data-toggle="tooltip"
                              data-placement="right"
                              title={t('phrase:deadline claim')}
                            >
                              <i className="danger fas fa-exclamation-circle"></i>
                            </span>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <DatePicker
                              minDate={period_start}
                              shouldCloseOnSelect={false}
                              locale="pt_BR"
                              dateFormat="dd/MM/yyyy"
                              customInput={<Form.Control />}
                              selected={rule.claim_start}
                              onChange={(date) =>
                                handleChangeRule('claim_start', date, k)
                              }
                              placeholderText={t('label:start date')}
                              startDate={rule.claim_start}
                              endDate={rule.claim_end}
                              required
                            />
                          </Col>
                          <Col>
                            <DatePicker
                              minDate={period_start}
                              shouldCloseOnSelect={false}
                              locale="pt_BR"
                              dateFormat="dd/MM/yyyy"
                              customInput={<Form.Control />}
                              selected={rule.claim_end}
                              onChange={(date) =>
                                handleChangeRule('claim_end', date, k)
                              }
                              placeholderText={t('label:end date')}
                              startDate={rule.claim_start}
                              endDate={rule.claim_end}
                              required
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col md={6}>
                      <Form.Group>
                        <Row>
                          <Col>
                            <Form.Label className="mr-2">
                              {t('label:refunds')}
                            </Form.Label>
                            <span
                              style={{ color: '#D71925' }}
                              data-toggle="tooltip"
                              data-placement="right"
                              title={t('phrase:deadline refund')}
                            >
                              <i className="danger fas fa-exclamation-circle"></i>
                            </span>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <DatePicker
                              minDate={period_start}
                              shouldCloseOnSelect={false}
                              locale="pt_BR"
                              dateFormat="dd/MM/yyyy"
                              customInput={<Form.Control />}
                              selected={rule.refunds_start}
                              onChange={(date) =>
                                handleChangeRule('refunds_start', date, k)
                              }
                              placeholderText={t('label:start date')}
                              startDate={rule.refunds_start}
                              endDate={rule.refunds_end}
                              required
                            />
                          </Col>
                          <Col>
                            <DatePicker
                              minDate={period_start}
                              shouldCloseOnSelect={false}
                              locale="pt_BR"
                              dateFormat="dd/MM/yyyy"
                              customInput={<Form.Control />}
                              selected={rule.refunds_end}
                              onChange={(date) =>
                                handleChangeRule('refunds_end', date, k)
                              }
                              placeholderText={t('label:end date')}
                              startDate={rule.refunds_start}
                              endDate={rule.refunds_end}
                              required
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </Col>
                  </Row>
                </Card>
              ))}
          </Col>
        </Row>
        <Row className="mt-2">
          <Col>
            <Form.Group>
              <Form.Label>{t('label:comment')}</Form.Label>
              <Form.Control
                as="textarea"
                value={historyComment}
                onChange={(e) => setHistoryComment(e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col>
            <Button className="login-btn mr-1" variant="primary-login" size="md" type="submit">
              {t('label:save')}
            </Button>
          </Col>
        </Row>
        <History histories={histories} />
      </Card.Body>
    </Form>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  createOrEditCompanyRule: (payload) => {
    if (!payload.id) dispatch({ type: ASYNC_CREATE_COMPANY_RULE, payload });
    else dispatch({ type: ASYNC_EDIT_COMPANY_RULE, payload });
  },
});

const reduxConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(CompanyRulesForm);

export default MasterPage(reduxConnect);
